import AccountDetailsReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/AccountDetailsReducer";
import ChangeCustomerWarehouseDataReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/ChangeCustomerWarehouseReducer";
import ChangeOrderHistoryReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/ChangeOrderHistoryReducer";
import ContactUsFormLocationsReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/ContactUsFormLocationsReducer";
import CustomAccountShipToReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/CustomAccountShipToReducer";
import CustomOrderStatusPageReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/CustomOrderStatusPageReducer";
import CustomShippingFieldReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/CustomShippingFieldReducer";
import OrderDetailsCustomReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/OrderDeatilsCustom/OrderDetailsCustomReducer";
import OrderHistoryDateRangeValidatorReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/OrderHistoryDateRangeValidatorReducer";
import OrderDataReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/OrderHistoryStatus";
import CreateQuoteReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/OsnQuotes/CreateQuoteReducer";
import QuoteListReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/OsnQuotes/QuoteListReducer";
import SubscriptionsDashboardReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/OsnSubscriptionsDashboard/SubscriptionsDashboard";
import PODDataReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/PODDataReducer";
import CustomWarehousesReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/WarehousesReducer";
import { combineReducers } from "redux";

import CustomBillToReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/CustomBillToReducer";
import ProductListIsStockAvailableReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/ProductListIsStockAvailableReducer";
import ReturnOrdersReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/ReturnOrdersReducer";
import StockWarehouseReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/StockWarehouseReducer";

const customDataReducerData = {
    customShippingField: CustomShippingFieldReducer,
    podDataStore: PODDataReducer,
    changeCustomerWarehouseData: ChangeCustomerWarehouseDataReducer,
    orderStatus: OrderDataReducer,
    changeOrderHistoryReducer: ChangeOrderHistoryReducer,
    accountInformationStore: AccountDetailsReducer,
    accountShipToReducer: CustomAccountShipToReducer,
    subscriptionsDashboardData: SubscriptionsDashboardReducer,
    customOrderStatusPage: CustomOrderStatusPageReducer,
    warehouses: CustomWarehousesReducer,
    osnQuotes: QuoteListReducer,
    orderHistoryDateRangeValidatorStore: OrderHistoryDateRangeValidatorReducer,
    osnCreateOrEditQuote: CreateQuoteReducer,
    orderDetailsCustom: OrderDetailsCustomReducer,
    productListIsStockAvailableStore: ProductListIsStockAvailableReducer,
    stockWarehouseStore: StockWarehouseReducer,
    customBillToData: CustomBillToReducer,
    returnOrderStore: ReturnOrdersReducer,
    branches: ContactUsFormLocationsReducer,
};

export type DataReducers = typeof customDataReducerData;

const customDataReducer = combineReducers(customDataReducerData as any);

export default customDataReducer;
